"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceRoutingParameters = exports.RoutingContext = void 0;
const react_1 = require("react");
const useCulture_1 = __importDefault(require("./useCulture"));
exports.RoutingContext = (0, react_1.createContext)({
    domain: '',
    isExternal: false,
    pushMethod: () => null,
    patterns: {
        home: '',
        homeModule: '',
        operation: '',
        sponsorship: '',
    },
});
const MATCH_ROUTING_PARAMETERS = /:((\w|\d){1,50})/g;
const replaceRoutingParameters = (str, data = {}) => {
    return str.replace(MATCH_ROUTING_PARAMETERS, (_m, prop) => (data[prop] ? String(data[prop]).toLowerCase() : `:${prop}`));
};
exports.replaceRoutingParameters = replaceRoutingParameters;
const useRouting = () => {
    const { domain, isExternal, pushMethod, customValidation, patterns } = (0, react_1.useContext)(exports.RoutingContext);
    const { culture } = (0, useCulture_1.default)();
    const locale = culture === null || culture === void 0 ? void 0 : culture.locale;
    const interpolate = (str, data = {}) => {
        const interpolatedUrl = (0, exports.replaceRoutingParameters)(str, data);
        const withDomain = interpolatedUrl.indexOf(domain) === -1;
        const isUrl = new RegExp('^https?://').test(interpolatedUrl);
        return isExternal && withDomain && !isUrl ? domain + interpolatedUrl : interpolatedUrl;
    };
    const generateHomeUrl = (home, name) => {
        const basePath = (typeof patterns.home === 'function' ? patterns.home(home) : patterns.home);
        const homeName = home ? home.name : name;
        if (!homeName || !locale)
            return;
        return interpolate(basePath, { homeName, locale });
    };
    const generateHomeModuleUrl = (homeName, homeModuleName) => {
        if (!locale)
            return;
        return interpolate(patterns.homeModule, {
            homeName,
            locale,
            moduleName: homeModuleName,
        });
    };
    const generateSponsorshipUrl = () => {
        if (!locale)
            return;
        return interpolate(patterns.sponsorship, { locale });
    };
    const generateOperationUrl = (operationId) => {
        if (!locale)
            return;
        return interpolate(patterns.operation, { id: operationId, locale });
    };
    const redirect = (url, forcedExternal, payload) => {
        const validationFn = customValidation ? () => customValidation(payload, url) : undefined;
        forcedExternal || isExternal ? (window.location.href = url) : pushMethod(url, validationFn);
    };
    return {
        generateHomeModuleUrl,
        generateHomeUrl,
        generateOperationUrl,
        generateSponsorshipUrl,
        interpolate,
        redirect,
        customValidation,
    };
};
exports.default = useRouting;
